
import PageContentLayout from '../PageContentLayout.vue';
export default {
  components: { PageContentLayout }
};
